































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateIntegrationSettingsRequest from '@/models/Integrations/UpdateIntegrationSettingsRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'IntegrationSettingsEdit'
})
export default class extends GiganautVueDialog {

  public entity = new UpdateIntegrationSettingsRequest();

  // Sensitive settings arrive from the API with their value replaced by this
  // mask literal (SENSITIVE_SETTING_MASK on the backend); the mask must
  // never be an editable value (users would save the literal asterisks as
  // their API key). Those fields render LOCKED: disabled and empty, padlock
  // button alongside. Locked on save → the mask sentinel is sent and the
  // backend keeps the stored secret (the dialog saves all settings at once,
  // so this is what lets you edit one setting without re-typing every
  // secret). Unlocking is the explicit "I'm changing this" gesture — the
  // field enables empty and whatever it holds on save is stored verbatim,
  // including blank to clear the secret. Re-locking discards any typed
  // value and reverts to keep-existing.
  readonly SENSITIVE_MASK = '**********';
  public maskedKeys: string[] = [];
  public unlockedKeys: string[] = [];

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new UpdateIntegrationSettingsRequest();
      this.entity.settings = JSON.parse(JSON.stringify(AgencySettingsModule.currentIntegration.settings));
      this.maskedKeys = [];
      this.unlockedKeys = [];
      for (const setting of this.entity.settings) {
        if (setting.value === this.SENSITIVE_MASK) {
          this.maskedKeys.push(setting.key);
          setting.value = '';
        }
      }
    }
  }

  isLocked(key: string): boolean {
    return this.maskedKeys.includes(key) && !this.unlockedKeys.includes(key);
  }

  toggleLock(setting: { key: string; value: string }) {
    const index = this.unlockedKeys.indexOf(setting.key);
    if (index >= 0) {
      this.unlockedKeys.splice(index, 1);
      setting.value = '';
    } else {
      this.unlockedKeys.push(setting.key);
    }
  }

  securePlaceholder(key: string): string {
    if (!this.maskedKeys.includes(key)) {
      return '';
    }
    return this.isLocked(key)
      ? 'Value is set — click the padlock to change it'
      : 'Enter a new value — warning: saving while blank and unlocked will clear any existing value';
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    // Locked secure fields mean "keep the existing secret" — send the mask
    // sentinel so the backend preserves the stored value. Unlocked fields
    // save exactly what they hold, blank included (explicit clear).
    for (const setting of this.entity.settings) {
      if (this.isLocked(setting.key)) {
        setting.value = this.SENSITIVE_MASK;
      }
    }
    this.entity.updatedAt = AgencySettingsModule.currentIntegration.updatedAt;
    await AgencySettingsModule.editIntegrationSettings(this.entity)
    this.dialog = false;
  }
}
